import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/pages/home/home'
import richText from '@/pages/home/richText'
import bannerTaskList from '@/pages/home/bannerTaskList'
import newsInfo from '@/pages/userInfo/newsInfo'
import certiInfo from '@/pages/userInfo/certiInfo'
import task from '@/pages/task/task'
import login from '@/pages/login/login'
import loginNumber from '@/pages/login/loginNumber'
import register from '@/pages/login/register'
import forgetPassword from '@/pages/login/forgetPassword'
import taskDetail from '@/pages/task/taskDetail'
import hall from '@/pages/hall/hall'
import hallDetail from '@/pages/hall/hallDetail'
import userInfo from '@/pages/userInfo/userInfo'
import collection from '@/pages/collection/collection'
import myprice from '@/pages/myprice/myprice'
import mypoints from '@/pages/mypoints/mypoints'
import myCoverWork from '@/pages/myCoverWork/myCoverWork'
import mycontract from '@/pages/mycontract/mycontract'
import feedback from '@/pages/feedback/feedback'
import report from '@/pages/report/report'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'myCoverWork',
    //   component: myCoverWork
    // },
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/login/login',
      name: 'login',
      component: login
    },
    {
      path: '/home/newsInfo',
      name: 'newsInfo',
      component: newsInfo
    },
    {
      path: '/home/richText',
      name: 'richText',
      component: richText
    },
    {
      path: '/home/bannerTaskList',
      name: 'bannerTaskList',
      component: bannerTaskList
    },
    {
      path: '/login/loginNumber',
      name: 'loginNumber',
      component: loginNumber
    },
    {
      path: '/login/forgetPassword',
      name: 'forgetPassword',
      component: forgetPassword
    },
    {
      path: '/login/register',
      name: 'register',
      component: register
    },

    {
      path: '/home/home',
      name: 'home',
      component: home
    },
    {
      path: '/task/task',
      name: 'task',
      component: task
    },
    {
      path: '/task/taskDetail',
      name: 'taskDetail',
      component: taskDetail
    },
    {
      path: '/hall/hall',
      name: 'hall',
      component: hall
    },
    {
      path: '/hall/hallDetail',
      name: 'hallDetail',
      component: hallDetail
    },
    {
      path: '/userInfo/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/userInfo/certiInfo',
      name: 'certiInfo',
      component: certiInfo
    },
    {
      path: '/myprice/myprice',
      name: 'myprice',
      component: myprice
    },
    {
      path: '/mypoints/mypoints',
      name: 'mypoints',
      component: mypoints
    },
    {
      path: '/collection/collection',
      name: 'collection',
      component: collection
    },
    {
      path: '/myCoverWork/myCoverWork',
      name: 'myCoverWork',
      component: myCoverWork
    },
    {
      path: '/mycontract/mycontract',
      name: 'mycontract',
      component: mycontract
    },
    {
      path: '/feedback/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/report/report',
      name: 'report',
      component: report
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js